import styled, { createGlobalStyle } from 'styled-components';
import { COLORS } from 'modules/core/theme/colors';
import { ROBOTO_FONT_FAMILY } from 'modules/core/theme/typography';
import { WindowBreakpoints } from 'modules/core/enums/windowBreakpoints.enum';

export const SELECT_LENDER_BACKDROP_CLASS = 'select-lender-backdrop';
export const SELECT_LENDER_MODAL_OPEN_BODY_CLASS = 'select-lender-modal-open';

export const SelectLenderGlobalStyles = createGlobalStyle`
  @property --border-angle {
    syntax: "<angle>";
    inherits: false;
    initial-value: 0deg;
  }

  @keyframes spin-border {
    0% { --border-angle: 0deg; }
    to { --border-angle: 360deg; }
  }

  body.${SELECT_LENDER_MODAL_OPEN_BODY_CLASS} #root {
    filter: blur(5px);
  }

  .${SELECT_LENDER_BACKDROP_CLASS}.modal-backdrop.show {
    --bs-backdrop-bg: rgba(0, 0, 0, 0.45);
    --bs-backdrop-opacity: 1;
    background-color: rgba(0, 0, 0, 0.45) !important;
    opacity: 1 !important;
  }
`;

export const MODAL_DIALOG_STYLE = `
  .modal-dialog.modal-dialog {
    margin-top: 12vh;
  }

  .modal-content {
    border: none;
    border-radius: 16px;
    overflow: hidden;
  }

  .modal-body {
    padding: 0;
  }
`;

export const DialogContainer = styled.div`
  font-family: ${ROBOTO_FONT_FAMILY};
  color: ${COLORS.BLACK_2};
`;

export const DialogHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 28px 16px;
  border-bottom: 1px solid ${COLORS.WHITE_3};
`;

export const HeaderLogo = styled.img`
  height: 22px;
  width: auto;
  filter: brightness(0);
`;

export const HeaderTitle = styled.span`
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: ${COLORS.BLACK_2};
  text-transform: uppercase;
`;

export const DialogBody = styled.div`
  padding: 20px;
`;

export const ContentPanel = styled.div`
  padding: 24px;
  border-radius: 12px;
  background-color: ${COLORS.WHITE};
  box-shadow: 0 2px 12px rgba(14, 39, 86, 0.06);
`;

export const DialogContent = styled.div``;

export const Section = styled.section`
  &:not(:last-child) {
    margin-bottom: 28px;
  }
`;

export const SectionTitle = styled.h2`
  margin: 0 0 16px;
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.BLACK_2};
`;

export const MakeItWorkText = styled.span`
  font-style: italic;
  font-weight: 600;
`;

export const OptionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: ${WindowBreakpoints.small}px) {
    grid-template-columns: 1fr;
  }
`;

export const OptionCard = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 56px;
  padding: 16px 20px;
  border: 2px solid transparent;
  border-radius: 8px;
  background-color: ${COLORS.WHITE};
  box-shadow: 0 2px 10px rgba(14, 39, 86, 0.1);
  cursor: pointer;
  text-align: left;
  font-size: 15px;
  font-weight: 500;
  color: ${COLORS.BLACK_2};
  transition: background-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, color 0.15s ease-in-out;

  &::before {
    content: '';
    position: absolute;
    inset: -2px;
    padding: 2px;
    border-radius: inherit;
    background: linear-gradient(90deg, #3dd3f3, #0561d9, #5dd7f6, #0561d9, #3dd3f3);
    mask: linear-gradient(#fff 0 0) content-box exclude, linear-gradient(#fff 0 0);
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.15s ease-in-out;
  }

  @supports (background: conic-gradient(from 0deg, red, blue)) {
    &::before {
      background: conic-gradient(from var(--border-angle), #3dd3f3, #0561d9, #5dd7f6, #0561d9, #3dd3f3);
      animation: spin-border 3s linear infinite;
    }
  }

  &:hover {
    background-color: ${COLORS.BLUE_5};
    color: ${COLORS.WHITE};
    box-shadow: 0 4px 14px rgba(14, 39, 86, 0.14);

    &::before {
      opacity: 1;
    }

    @supports (background: conic-gradient(from 0deg, red, blue)) {
      &::before {
        animation-duration: 1.5s;
      }
    }

    ${() => ChevronIcon} {
      color: ${COLORS.WHITE};
    }
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.BLUE_12};
    outline-offset: 2px;
  }
`;

export const OptionLabel = styled.span`
  padding-right: 12px;
`;

export const ChevronIcon = styled.span`
  flex-shrink: 0;
  font-size: 18px;
  line-height: 1;
  color: ${COLORS.GREY_24};
  font-weight: 400;
`;
